import { Result } from 'core/infrastructure';
import { Preconditions } from 'core/infrastructure-next';
import { Command } from 'pos/common';
import { Permission } from 'core/api';
import { AppointmentFacade } from 'pos/facades';

declare global {
	interface CommandType {
		cancelAppointment: (appointmentId: number) => Promise<Result>;
	}
}

Command.register('cancelAppointment', Preconditions.and(Preconditions.ensure(Permission.Appointment_Cancel), Preconditions.ensureIsNotLite), async (id: number): Promise<Result> => {
	await AppointmentFacade.cancel(id);
	return Result.ok();
});
